import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown";

export default function AllProject(props) {
  const data = useStaticQuery(graphql`
    query ProjectsQuery {
      allProjects: allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___title] }
        filter: { frontmatter: { templateKey: { eq: "projects" } } }
      ) {
        edges {
          node {
            id
            fields {
              slug
            }
            frontmatter {
              title
              externalUrl
              logo
            }
            rawMarkdownBody
          }
        }
      }
    }
  `);

  return (
    <div>
      {data.allProjects.edges.map(({ node }) => {
        const {
          rawMarkdownBody,
          frontmatter: { title, externalUrl, logo }
        } = node;
        return (
          <div>
            <h2>{title}</h2>
            {logo && <img src={logo} alt={title} />}
            {externalUrl && <a href={externalUrl}>Povezava</a>}
            {rawMarkdownBody && (
              <ReactMarkdown source={rawMarkdownBody} escapeHtml={false} />
            )}
          </div>
        );
      })}
    </div>
  );
}
